import { Component, OnInit } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { ReviewService } from '../../services/review.service';
import { ReviewData } from '../../models';

@Component({
    selector: 'app-review',
    imports: [FormsModule, RouterModule],
    templateUrl: './review.component.html',
    styleUrls: ['./review.component.css']
})
export class ReviewsComponent implements OnInit {

  // Available tags for combobox
  availableTags = [
    { emoji: '🐐', label: 'GOAT (Greatest of All Time)' },
    { emoji: '🦀', label: 'Crab (Negative influencer)' },
    { emoji: '💰', label: 'Value for Money' },
    { emoji: '😴', label: 'Lazy' },
    { emoji: '💼', label: 'Strong Leader' },
    { emoji: '👎', label: 'Poor Performer' }
  ];

  selectedTag: any = null;
  aiTags: Array<{ emoji: string; label: string }> = [];

  productHash: string = '';
  link: string = '';
  imageUrl: string = '';
  title: string = 'Review Page';

  // Stats
  viewCount: number = 0;
  likes: number = 0;

  // AI-driven traits
  category: string = '';
  emoji: string = '';
  label: string = '';
  description: string = '';

  loading: boolean = true;

  constructor(
    private route: ActivatedRoute,
    private reviewService: ReviewService
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.link = window.location.href; // Current URL

      // Initialize the service with the link (generates hash once)
      this.reviewService.setLink(this.link);
      this.productHash = this.reviewService.getProductHash();

      this.imageUrl = `https://source.unsplash.com/800x400/?${this.productHash}`;
      this.title = `Review: ${this.productHash}`;

      // Load data from KV storage using the link
      this.loadReviewData();
    });
  }

  private loadReviewData(): void {
    this.loading = true;

    this.reviewService.getReview().subscribe({
      next: (data: ReviewData) => {
        this.productHash = data.productHash; // Get the hash from response
        this.viewCount = data.viewCount;
        this.likes = data.likes;
        this.link = data.link || this.link;

        // If this is the first time, save the link
        if (!data.link) {
          this.updateLink();
        }

        // Increment view count
        this.incrementViewCount();

        this.loading = false;
        this.assignCategory();
      },
      error: (error) => {
        console.error('Error loading review data:', error);
        this.loading = false;
        // Still increment view and save link for new pages
        this.updateLink();
        this.incrementViewCount();
        this.assignCategory();
      }
    });
  }

  private updateLink(): void {
    this.reviewService.updateReview({
      link: this.link
    }).subscribe({
      next: (data: ReviewData) => {
        console.log('Link saved successfully');
      },
      error: (error) => {
        console.error('Error saving link:', error);
      }
    });
  }

  private incrementViewCount(): void {
    this.reviewService.incrementView().subscribe({
      next: (data: ReviewData) => {
        this.viewCount = data.viewCount;
      },
      error: (error) => {
        console.error('Error incrementing view count:', error);
      }
    });
  }

  likeProduct(): void {
    this.reviewService.incrementLike().subscribe({
      next: (data: ReviewData) => {
        this.likes = data.likes;
      },
      error: (error) => {
        console.error('Error incrementing likes:', error);
      }
    });
  }

  addTag(): void {
    if (this.selectedTag) {
      this.aiTags.push(this.selectedTag);
      this.selectedTag = null;
      // You can add logic here to save tags if needed
    }
  }

  private assignCategory(): void {
    // Simulate AI prediction logic
    const categories = [
      { name: 'value', emoji: '💰', label: 'Great Value', desc: 'Offers high value for the price' },
      { name: 'goat', emoji: '🐐', label: 'GOAT', desc: 'Greatest of all time performer' },
      { name: 'crab', emoji: '🦀', label: 'Crab', desc: 'Pulls others down, avoidable behavior' },
      { name: 'lazy', emoji: '🐢', label: 'Lazy', desc: 'Slow, lacks motivation' },
      { name: 'leader', emoji: '🦁', label: 'Leader', desc: 'Inspires and leads others effectively' },
      { name: 'worst', emoji: '💀', label: 'Poor Performer', desc: 'Needs significant improvement' }
    ];

    const random = categories[Math.floor(Math.random() * categories.length)];
    this.category = random.name;
    this.emoji = random.emoji;
    this.label = random.label;
    this.description = random.desc;
  }
}

